/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Icon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'



/** @type {import('Simple/types.js').View} */
export default function Icon({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/Problem/Content/Content/Icon"
  
}) {
let dtColorsBlue600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.600'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaIconInfoFilled
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 fill={dtColorsBlue600}
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 width={14}
 height={14}
/>
{children}
</React.Fragment>)
}